import { getBlockedErrMsg } from 'common/components/BlockedErrMsg';
import { ACCOUNT_TYPE } from 'common/constants/Constants';
import JSRuntime from 'common/utils/JSRuntime';

/** 企业认证认证状态 */
export enum ENT_AUTH_STATUS {
  UNKNOWN = 0,
  INITIAL = 1,
  /** 认证中 */
  INPROGRESS = 2,
  /** 认证失败 */
  FAIL = 3,
  /** 认证成功 */
  SUCCESS = 4,
  /** 过期 */
  EXPIRED = 5,
  /** 失效 */
  INVALID = 6,
  /** 即将过期 */
  COMINGEXPIRED = 7,
  /** 撤回状态 */
  WITHDRAW = 8,
}

export enum ENTERPRISE_AUTH_TYPE {
  ENTERPRISE_AUTH = 'enterprise',
  ORG_AUTH = 'organization',
}
// 这是ENTERPRISE_AUTH_TYPE.ENTERPRISE_AUTH的子类型
export enum ENTERPRISE_CERT_TYPES {
  ELECTRICAL_BUSINESS_LICENSE = 1,
  ENTERPRISE_AUTHORIZATION_LETTER = 2,
  TENCENT_CLOUD = 4,
}
// 这是ENTERPRISE_AUTH_TYPE.ORG_AUTH的子类型
export enum ORG_CERT_TYPES {
  ORG_AUTHORIZATION_LETTER = 3,
}

// 账号被封禁时错误码
export const BLOCKED_ERROR_CODE = 'E0010344';

export const BLOCKED_ERROR_MSG = {
  [BLOCKED_ERROR_CODE]: getBlockedErrMsg(),
};

/** 认证类型，企业认证与个人认证 */
export enum AUTH_TYPE_ENUM {
  /** 个人认证 */
  PERSONAL = 'personal',
  /** 企业认证 */
  ENTERPRISE = 'enterprise',
}

/** 认证类型，区分企业认证个人认证，与接入应用的传参进行对应 */
export enum AUTH_TYPE {
  /** 是否认证过 */
  UNKNOWN = 0,
  /** 达人 */
  KOL = 1,
  /** 职业 */
  OCCUPATION = 2,
  // /** 企业 */
  // ENTPRISE = 3,
  // /** 组织 */
  // ORGANIZATION = 4,
}
/** 企业认证的具体认证类型 */
export enum ENT_AUTH_TYPE {
  /** 未知认证方式 */
  UNKNOWN = 0,
  /** 电子营业执照 */
  LICENSE = 1,
  /** 企业授权函 */
  ENTERPRISE = 2,
  /** 组织机构授权函 */
  ORGANIZATION = 3,
  /** 腾讯云认证 */
  TENCENT = 4,
}

/** 保存类型，企业认证中使用 */
export enum SAVE_TYPE {
  /** 草稿 */
  DRAFT = 1,
  /** 提交审核 */
  APPLY = 2,
}

export const RESET_PWD_ERROR_CODE = ['E0010381', 'E0010382', 'E0010383', 'E0010384', 'E0010451'];

/**
 * 企业微信名片ocr字段
 * mobile/name/account/profession/email
 */
export const enum WECHAT_OCR_FIELD {
  /** 手机号 */
  MOBILE = 'mobile',
  /** 姓名 */
  NAME = 'name',
  /** 企业 */
  ACCOUNT = 'account',
  /** 职位 */
  PROFESSION = 'profession',
  /** 邮箱 */
  EMAIL = 'email',
}

/**
 * 企业微信名片ocr字段对应名称
 * mobile/name/account/profession/email
 */
export const WECHAT_OCR_FIELD_NAME = {
  /** 手机号 */
  [WECHAT_OCR_FIELD.MOBILE]: '手机',
  /** 姓名 */
  [WECHAT_OCR_FIELD.NAME]: '姓名',
  /** 企业 */
  [WECHAT_OCR_FIELD.ACCOUNT]: '企业',
  /** 职位 */
  [WECHAT_OCR_FIELD.PROFESSION]: '职位',
  /** 邮箱 */
  [WECHAT_OCR_FIELD.EMAIL]: '邮箱',
};

/** 单个OCR信息 */
export interface IOcrSingleInfo {
  /** 解析数据名称 */
  key: WECHAT_OCR_FIELD;
  /** 解析数据内容 */
  value: string;
}

/** OCR接口返回 */
export interface IImgOcrInfo {
  /** OCR信息 */
  ocr_info: IOcrSingleInfo[];
  /** 识别mobile是否与会议登陆号码一致 */
  is_login_phone: boolean;
}

export interface IFaceAuthInfo {
  biz_token: string;
  request_id: string;
  url: string;
}

export interface IFaceAuthPolling {
  is_certify: boolean;
  is_face_auth: boolean;
  name: string;
  request_id: string;
}

export const enum SMS_CODE_TYPE {
  UNKNOWN = 0,
  LOGIN_MOBILE = 1,
  MATERIAL_MOBILE = 2,
  MATERIAL_EMAIL = 3,
}
/** 通用认证状态（个人认证定义） */
export enum AUTH_STATUS {
  INIT = 0,
  /** 认证中 */
  REVIEW = 1,
  /** 认证成功 */
  SUCCESS = 2,
  /** 认证失败 */
  FAIL = 3,
  /** 撤回状态 */
  REVOCATION = 4,
  /** 认证过期 */
  EXPIRE = 5,
  /** 认证失效 */
  DISABLED = 6, // 认证失效,例如举报失效
}

/** 企业认证状态与通用认证状态对应 */
export const AUTH_STATUS_NOMARL = {
  /** */
  [ENT_AUTH_STATUS.INITIAL]: AUTH_STATUS.INIT,
  /** 认证成功 */
  [ENT_AUTH_STATUS.SUCCESS]: AUTH_STATUS.SUCCESS,
  /** 认证失败 */
  [ENT_AUTH_STATUS.FAIL]: AUTH_STATUS.FAIL,
  /** 认证过期 */
  [ENT_AUTH_STATUS.EXPIRED]: AUTH_STATUS.EXPIRE,
  /** 认证失效 */
  [ENT_AUTH_STATUS.INVALID]: AUTH_STATUS.DISABLED,
  /** 认证中 */
  [ENT_AUTH_STATUS.INPROGRESS]: AUTH_STATUS.REVIEW,
};

export const IDP_RIGHT_BG_DOC = `${JSRuntime.cdnUrl}/images/idp-right-bg-doc.jpg`;

/** 企业sso登录 */
export const ENTERPRISE_LOGIN_TYPE = 'sso';

/** 认证的账号 */
export interface IAuthenticatedAccount {
  id: string;
  in_handshake: boolean;
  inviter_name: string;
  logo_url: string;
  name: string;
  type: ACCOUNT_TYPE;
  union_id: string;
  user_name?: string;
}

/**
 * auth prompt
 */
export enum AUTH_PROMP {
  /** 关联的场景现状：1. 创建账号 */
  SKIP_SELECT_ACCOUNT = 'skip_select_account',
  /** 关联的场景现状：1. 未加入企业; 2. 企业账号禁用 */
  SKIP_CHECK_ACCOUNT = 'skip_check_account',
}

/** 登录方式 */
export enum LOGIN_METHOD {
  /** 手机号登录 */
  MOBILE,
  /** 邮箱登录 */
  EMAIL,
  /** SSO登录 */
  SSO,
  /** 自定义登录 - sso认证源 */
  CUSTOM,
}

/**
 * 页面类型
 */
export enum PAGE_TYPE {
  /** 手机号验证码页 */
  MOBILE,
  /** 选择企业列表页 */
  SELECT_ACCOUNT,
  /** 邀请页 */
  INVITATION,
  /** 解绑页 */
  UNBIND_ACCOUNTS,
  /** 注册页 */
  REGISTER,
  /** 无账号，创建企业页 */
  CREATE_ACCOUNT,
  /** 有账号，选择创建、登录、解绑页 */
  REGISTER_SELECT,
  /** 邮箱验证码页 */
  EMAIL,
}

export enum APP_LOGO_TYPE {
  ONE_ID = 'OneID',
  YUANBAO_BIZ = 'yuanbao-biz',
  DOC = 'doc',
}

/** URL 中 acr_values 参数的枚举值，用于指定登录方式 */
export enum ACR_VALUES {
  /** 手机号登录 */
  SMS = 'sms',
  /** 邮箱登录 */
  EMAIL = 'email',
  /** SSO 企业域名登录 */
  SSO_PREFERRED_DOMAIN = 'sso:preferred_domain',
  /** SSO 企业邮箱登录 */
  SSO_PREFERRED_EMAIL = 'sso:preferred_email',
}

/**
 * LOGIN_REACH_API_EVENT 的 verify_type 枚举，产品提供
 * @description 用于标识触发登录态种入接口的场景来源
 */
export enum LOGIN_VERIFY_TYPE {
  /** 其他 */
  OTHER = '0',
  /** 新用户注册 */
  NEW_USER_REGISTER = '1',
  /** 手机号验证码登录 */
  MOBILE_CODE_LOGIN = '2',
  /** 绑定邮箱 */
  BIND_EMAIL = '3',
  /** 绑定手机 */
  BIND_MOBILE = '4',
  /** 更换邮箱 */
  CHANGE_EMAIL = '5',
  /** 更换手机 */
  CHANGE_MOBILE = '6',
  /** 邮箱验证码登录 */
  EMAIL_CODE_LOGIN = '7',
  /** 重置密码 */
  RESET_PASSWORD = '8',
  /** 企业管理账户登录 */
  ENTERPRISE_ADMIN_LOGIN = '9',
  /** 管理员邀请人员 */
  ADMIN_INVITE = '10',
  /** 手机号账号列表选择 */
  MOBILE_ACCOUNT_SELECT = '11',
  /** 其他应用 */
  OTHER_APP = '12',
  /** 免费注册 */
  FREE_REGISTER = '13',
  /** 手机号 handshake 加入 */
  MOBILE_HANDSHAKE_JOIN = '14',
  /** SSO 账号密码 */
  SSO_PASSWORD = '15',
  /** SSO-AD */
  SSO_AD = '16',
  /** SSO-OpenLDAP */
  SSO_OPENLDAP = '17',
  /** SSO-AAD */
  SSO_AAD = '18',
  /** SSO-飞书 */
  SSO_LARK = '19',
  /** SSO-钉钉 */
  SSO_DINGTALK = '20',
  /** SSO-企微 */
  SSO_WEWORK = '21',
  /** SSO-私有化企微 */
  SSO_GOVWECHAT = '22',
  /** SSO-OAuth */
  SSO_OAUTH = '23',
  /** SSO-SAML */
  SSO_SAML = '24',
  /** SSO-CAS */
  SSO_CAS = '25',
  /** SSO-OIDC */
  SSO_OIDC = '26',
  /** SSO-JWT */
  SSO_JWT = '27',
  /** 邮箱账号列表选择 */
  EMAIL_ACCOUNT_SELECT = '28',
  /** 邮箱 handshake 加入 */
  EMAIL_HANDSHAKE_JOIN = '29',
}

/** 换绑手机号接口 `POST /admin/v2/person/mobile_change/par` 请求体 `action` 字段 */
export enum MOBILE_CHANGE_ACTION {
  /** 绑定 */
  BIND = 'bind',
  /** 解绑 */
  UNBIND = 'unbind',
  /** 换绑 */
  REBIND = 'rebind',
}

/** 换绑手机号接口 `POST /admin/v2/person/mobile_change/par` 请求体 `operation_flag` 字段 */
export enum MOBILE_CHANGE_OPERATION_FLAG {
  /** 仅变更当前账号 */
  SINGLE_ACCOUNT = 1,
  /** 变更该自然人下全部账号 */
  ALL_UNDER_NATURAL_PERSON = 2,
  /** 由用户在前端二选一 */
  BOTH = 3,
}

/** 埋点私参 submit_result 枚举值 */
export const enum SUBMIT_RESULT {
  /** 成功 */
  SUCCESS = '0',
  /** 失败 */
  FAIL = '1',
  /** 跳转加入页面 */
  GOTO_JOIN = '2',
  /** 跳转账号列表 */
  GOTO_ACCOUNT_LIST = '3',
  /** 跳转注册选择页面 */
  GOTO_REGISTER_SELECT = '4',
  /** 跳转注册信息填写页面 */
  GOTO_REGISTER_INFO = '5',
}

/** 登录触达事件，触发登录态种入接口时上报 */
export const LOGIN_REACH_API_EVENT = 'e#oneid_login_reach_api#submit#click';
